document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", (e) => {
        if (e.target.classList.contains("js-text-toggle")) {
            e.target.closest(".admission-deadlines__slide").classList.add("opened");
        }       
    });
});
